import { render } from "./DatabaseSyncJobLogs.vue?vue&type=template&id=2bead6b7"
import script from "./DatabaseSyncJobLogs.vue?vue&type=script&lang=js"
export * from "./DatabaseSyncJobLogs.vue?vue&type=script&lang=js"

import "./DatabaseSyncJobLogs.vue?vue&type=style&index=0&id=2bead6b7&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__